import axios from "axios";

export default function getOrderDetail(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/master-list/${uuid}/detail`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
